module.exports = __webpack_public_path__ + "static/media/chats.29e91ae7.svg";